<template>
  <div class="renewal-status full-height">
    <RenewalStatusModal v-model="showModal" :status="status" :title="title" />

    <BaseChart height="335px" chart-height="270px" dark :chart-data="mergedChartData" class="no-padding">
      <template #header>
        <Grid gaf="column" justify-content="space-between" class="q-px-md q-pt-md">
          <div class="text-body-3 text-ellipsis text-white-1">{{ title }}</div>

          <RDropdown
            v-model="selectedFinancialPeriodId"
            :loading="!chartData"
            :options="financialPeriods || []"
            option-label="abbreviation"
            option-value="id"
            emit-value
            map-options
            no-hint
            no-label
            dark
            input-bg-color
          />
        </Grid>
      </template>
    </BaseChart>
  </div>
</template>

<script>
import { baseChartMixin } from '@/reusable/base-chart/base-chart-mixin'
import * as apiTo from '@/modular-api'
// Components
import RenewalStatusModal from './RenewalStatusModal'

export default {
  components: {
    RenewalStatusModal
  },

  mixins: [baseChartMixin],

  data: () => ({
    showModal: false,
    status: null,
    financialPeriods: null,
    selectedFinancialPeriodId: null
  }),

  computed: {
    title() {
      if (!this.supportData) return 'Renewal status'
      return `Renewal status ${this.supportData.merge_data['[[ YEAR ]]']}`
    }
  },

  watch: {
    chartData(newVal) {
      newVal && this.generateChartTitle()
    },

    selectedFinancialPeriodId: 'getChartData'
  },

  created() {
    this.getAndSetFinancialPeriods()
    this.customChartData = {
      legend: {
        enabled: true,
        itemStyle: {
          color: 'white',
          fontWeight: 'normal',
          textOutline: false
        }
      },

      title: {
        verticalAlign: 'middle',
        floating: true,
        y: -5,
        style: {
          color: 'white',
          textAlign: 'center'
        },
        useHTML: true
      },

      chart: {
        backgroundColor: 'var(--r-graph-8)'
      },

      tooltip: {
        headerFormat: '',
        pointFormat: '{point.name}: <b>{point.y} </b>',
        shared: true
      },

      plotOptions: {
        pie: {
          allowPointSelect: false,
          cursor: 'pointer',
          innerSize: '80%',
          align: 'center',
          borderColor: 'transparent',
          colors: ['var(--r-graph-likely)', 'var(--r-graph-11)', 'var(--r-graph-10)'],
          center: ['50%'],
          size: '100%',
          crop: false,
          overflow: 'auto',
          dataLabels: {
            connectorShape: 'straight'
          },
          showInLegend: true
        },
        series: {
          cursor: 'pointer',
          point: {
            events: {
              click: e => this.openChartModal(e.point.name.toLowerCase())
            }
          },
          dataLabels: {
            crop: false,
            padding: 0,
            color: 'white',
            style: {
              textOutline: false,
              textAlign: 'center',
              fontSize: '10px',
              fontWeight: 300
            },
            enabled: true,
            format: `{point.y} <br/>{point.name}`
          }
        }
      }
    }
  },

  methods: {
    getAndSetFinancialPeriods() {
      apiTo.GET_FINANCIAL_PERIODS().then(({ data }) => {
        this.financialPeriods = data.result

        const currentFp = data.result.find(fp => fp.is_current)
        if (currentFp) this.selectedFinancialPeriodId = currentFp.id
      })
    },

    getChartData(financialPeriodId) {
      apiTo.GET_RENEWAL_STATUS_CHART(financialPeriodId).then(({ data }) => {
        this.chartData = data.result.chart
        this.supportData = data.result.support_data
      })
    },

    openChartModal(status) {
      this.status = status
      this.showModal = true
    },

    generateChartTitle() {
      const text = this.chartData.series[0].data.find(item => {
        return (item.name === 'Accepted' && item.y !== null) || item.name === 'Pending'
      })
      if (!text) return
      const html = `
           <div style="display: grid">
             <div class="text-heading-1">
               ${text.y || 0}
             </div>
             <div class="text-lowercase-btn">
               ${text.name}
             </div>
           </div>
           `
      this.$set(this.customChartData.title, 'text', html)
    }
  }
}
</script>
